import Role from './Role';

export const ROLE_LABELS: Record<Role, string> = {
  [Role.Owner]: 'Właściciel',
  [Role.User]: 'Użytkownik',
};

export const getRoleLabel = (role: Role): string => ROLE_LABELS[role];

// Użytkownik pierwszy — to domyślna, częstsza rola przy zapraszaniu.
export const ROLE_OPTIONS: { value: Role; label: string }[] = [
  Role.User,
  Role.Owner,
].map((value) => ({ value, label: ROLE_LABELS[value] }));
